import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProjectForm from '../../components/projects-component/ProjectForm';
import { useWallet } from '../../context/WalletContext';

function CreateProject() {
  const navigate = useNavigate();
  const { isConnected, connectWallet, loading } = useWallet();

  if (!isConnected) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center p-8 bg-white rounded-lg shadow-md max-w-md">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Wallet Connection Required</h2>
          <p className="text-gray-600 mb-6">Please connect your wallet to create a project.</p>
          <button
            onClick={connectWallet}
            disabled={loading}
            className="bg-indigo-600 text-white px-6 py-2 rounded-md hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Connecting...' : 'Connect Wallet'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-900">Create New Project</h1>
           
          </div>
          <ProjectForm
            onSubmitSuccess={() => {
              navigate('/projects');
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default CreateProject; 